(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
(function () {
  document.querySelectorAll('.lumiiflora-cart__qty-wrap').forEach(function (wrap) {
    var input = wrap.querySelector('.lumiiflora-cart__qty-input');
    if (!input) return;

    var decrease = wrap.querySelector('[data-qty-decrease]');
    var increase = wrap.querySelector('[data-qty-increase]');

    if (decrease) {
      decrease.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 0;
        input.value = Math.max(0, value - 1);
      });
    }

    if (increase) {
      increase.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 0;
        input.value = value + 1;
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-testimonial-v1"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLumiifloraReviews(section) {
    if (!section || section.dataset.reviewsInit === 'true') return;
    section.dataset.reviewsInit = 'true';

    var names = section.querySelectorAll('.lumiiflora-reviews__name');
    var quotes = section.querySelectorAll('.lumiiflora-reviews__quote');
    if (!names.length || !quotes.length) return;

    function activate(index) {
      names.forEach(function (name, i) {
        var isActive = i === index;
        name.classList.toggle('is-active', isActive);
        name.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      quotes.forEach(function (quote, i) {
        quote.classList.toggle('is-active', i === index);
      });
    }

    names.forEach(function (name) {
      name.addEventListener('click', function () {
        var index = parseInt(name.getAttribute('data-review-index'), 10);
        if (!isNaN(index)) activate(index);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.lumiiflora-reviews-section').forEach(initLumiifloraReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section && section.classList && section.classList.contains('lumiiflora-reviews-section')) {
      section.dataset.reviewsInit = 'false';
      initLumiifloraReviews(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
